import { render, staticRenderFns } from "./AllotmentComponent.vue?vue&type=template&id=46418492&scoped=true"
import script from "./AllotmentComponent.vue?vue&type=script&lang=js"
export * from "./AllotmentComponent.vue?vue&type=script&lang=js"
import style0 from "./AllotmentComponent.vue?vue&type=style&index=0&id=46418492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46418492",
  null
  
)

export default component.exports